var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"section-header"},[_vm._v("Projects")]),_vm._l((_vm.projects),function(project){return _c('project',{key:project.name,attrs:{"project":project}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }